export default "/kiban/_next/static/images/28_8L_3-2-3_withoutBH_stack-34bc2e2370a83e794c7cd181ccd1d116.png";